import { useCallback, useRef } from 'react';

const useChatScrollToBottom = () => {
  const scrollToBottom = useCallback((smooth = false) => {
    messagesEndRef.current?.scrollIntoView({
      behavior: smooth ? 'smooth' : 'instant',
      block: 'end',
    });
  }, []);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  return {
    scrollToBottom,
    messagesEndRef,
  };
};

export default useChatScrollToBottom;
